export default __webpack_public_path__ + "ea07e99caa43b73f8844e066c96a0ea4.svg";